<div
  class="nav nav-tabs"
  role="tablist"
  #tabsContainer
  (mousedown)="onMouseDown($event)"
  (mouseleave)="onMouseLeave()"
  (mouseup)="onMouseUp()"
  (mousemove)="onMouseMove($event)"
>
  <div class="nav-item" *ngFor="let tab of tabsList">
    <button
      class="nav-link"
      [class.active]="isActive(tab)"
      [class.disabled]="tab.disabled"
      [attr.disabled]="tab.disabled ? true : null"
      (click)="!tab.disabled && selectTab(tab)"
      type="button"
      role="tab"
      [attr.aria-controls]="idOf(tab)"
      [attr.aria-selected]="isActive(tab)"
      [id]="btnId(tab)"
    >
      {{ tab.title }}
    </button>
  </div>
</div>

<div class="tab-content" [attr.id]="name + '-content'">
  <div
    *ngFor="let tab of tabsList"
    class="tab-pane"
    [class.active]="isActive(tab)"
    [id]="idOf(tab)"
    role="tabpanel"
    [attr.aria-labelledby]="btnId(tab)"
  >
    <ng-container *ngTemplateOutlet="tab.content"></ng-container>
  </div>
</div>